import { render } from "./DeleteItemComponent.vue?vue&type=template&id=2c8f32a2&scoped=true"
import script from "./DeleteItemComponent.vue?vue&type=script&lang=js"
export * from "./DeleteItemComponent.vue?vue&type=script&lang=js"

import "./DeleteItemComponent.vue?vue&type=style&index=0&id=2c8f32a2&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c8f32a2"]])

export default __exports__